import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-100 dark:bg-gray-800 text-center py-6 text-sm text-gray-600 dark:text-gray-300">
      <div className="flex justify-center flex-wrap gap-4">
        <Link to="/privacy-policy" className="hover:underline transition-colors duration-200">
          Privacy Policy
        </Link>
        <Link to="/terms" className="hover:underline transition-colors duration-200">
          Terms & Conditions
        </Link>
        <Link to="/about" className="hover:underline transition-colors duration-200">
          About / Contact
        </Link>
      </div>

      <p className="mt-3 text-xs text-gray-500 dark:text-gray-400">
        &copy; {new Date().getFullYear()} <strong>Imagera Web-App</strong>. All rights reserved.
      </p>
    </footer>
  );
};

export default Footer;